export default "__VITE_PUBLIC_ASSET__5d834c8d__"